import React from 'react';
import { DashboardClosedByMonthPivotMode } from '../../../../../constants/DashboardClosedByMonthPivotMode';
import { DashboardClosedByMonthPivotToggleButton } from './components/DashboardClosedByMonthPivotToggleButton';

export const Toolbar: React.FC<{
    pivotMode: DashboardClosedByMonthPivotMode;
    set_pivotMode: (mode: DashboardClosedByMonthPivotMode) => void;
}> = ({ pivotMode, set_pivotMode }) => {
    return (
        <div className='mode-bar'>
            <div className='mode-item'>Closed Loans T-12</div>
            <div className='mode-item'>
                Closed By Month
                <span className='toggle-wrapper'>
                    <DashboardClosedByMonthPivotToggleButton
                        pivotMode={pivotMode}
                        set_pivotMode={set_pivotMode}
                    />
                </span>
            </div>
        </div>
    );
};
